namespace Matrix {

    @Serenity.Decorators.registerFormatter([Serenity.ISlickFormatter, Serenity.IInitializeColumn])
    export class TemplateUrlFormatter implements Serenity.ISlickFormatter, Serenity.IInitializeColumn {

        constructor() {
            this.target = '_blank';
        }

        public static microFormatUrlHandler(token: string, data: any, offset: number, str: string) {

            var value = data[token];

            if (str == null)
                return encodeURIComponent(value ?? '');

            var queryIndex = str.indexOf('?');
            var hashIndex = str.indexOf('#');

            // temp solution until #edit url can handle url encoded values
            if (hashIndex >= 0 &&
                offset >= hashIndex &&
                str.indexOf('#edit', hashIndex) >= 0) {
                value = encodeURIComponent(value ?? '');
                if (value)
                    value = value.replace(/%7B/gi, '{').replace(/%7D/gi, '}');
                return value;
            }

            if (queryIndex >= 0 &&
                offset >= queryIndex &&
                (hashIndex < 0 || offset < hashIndex)) {

                var critIndex = str.toLowerCase().indexOf('&criteria=', queryIndex);
                if (critIndex < 0)
                    critIndex = str.toLowerCase().indexOf('?criteria=', queryIndex);

                if (critIndex >= 0 && offset > critIndex) {
                    var nextEq = str.indexOf('=', critIndex + "&criteria=".length);
                    if (nextEq >= 0 && (hashIndex >= 0 && hashIndex <= nextEq))
                        nextEq = hashIndex;
                    if (nextEq < 0 || offset < nextEq) {
                        if (value == null) {
                            return "null";
                        }
                        else if (typeof value == "string") {
                            return encodeURIComponent("'" + value.toString().replace("'", "''") + "'");
                        }
                        else if (typeof value == "number") {
                            return encodeURIComponent(value.toString());
                        }
                        else if (typeof value == "boolean") {
                            return value ? "1" : "0";
                        }
                        else {
                            return encodeURIComponent("'" + value.toString().replace("'", "''") + "'");
                        }
                    }
                }
            }

            return encodeURIComponent(value ?? "");
        }

        format(ctx: Slick.FormatterContext) {

            var url: string;
            if (this.url == null)
                url = Q.coalesce(ctx.value, '').toString();
            else
                url = Q.microFormat(this.url, ctx.item, {
                    handler: TemplateUrlFormatter.microFormatUrlHandler
                });

            if (url && Q.startsWith(url, '~/')) {
                url = Q.resolveUrl(url);
            }

            var text: string;
            if (Q.isEmptyOrNull(this.text)) {
                if (ctx?.column?.field)
                    text = Q.microFormat("{{" + ctx.column.field + "}}", ctx.item, {
                        htmlEncode: true
                    });
                else
                    text = Q.htmlEncode(url);
            }
            else {
                text = Q.microFormat(this.text, ctx.item, {
                    htmlEncode: this.isHtml
                });

                if (!this.isHtml)
                    text = Q.htmlEncode(text);
            }

            var s = "<a href='" + Q.attrEncode(url) + "'";

            if (!Q.isEmptyOrNull(this.target)) {
                s += " target='" + Q.attrEncode(this.target) + "'";
            }

            if (!Q.isEmptyOrNull(this.cssClass)) {
                s += " class='" + Q.attrEncode(Q.microFormat(this.cssClass, ctx.item)) + "'";
            }

            s += '>' + text + '</a>';

            return s;
        }

        initializeColumn(column: Slick.Column) {
            column.referencedFields = column.referencedFields || [];

            var referenced: Q.Dictionary<boolean> = {};

            var opt = {
                handler: (token: string) => {
                    referenced[token] = true;
                }
            };

            if (!Q.isEmptyOrNull(this.text)) {
                Q.microFormat(this.text, undefined, opt);
            }

            if (!Q.isEmptyOrNull(this.url)) {
                Q.microFormat(this.url, undefined, opt);
            }

            if (!Q.isEmptyOrNull(this.cssClass)) {
                Q.microFormat(this.cssClass, undefined, opt);
            }

            for (var x of Object.keys(referenced))
                column.referencedFields.push(x);
        }

        @Serenity.Decorators.option()
        text: string;

        @Serenity.Decorators.option()
        isHtml: boolean;

        @Serenity.Decorators.option()
        url: string;

        @Serenity.Decorators.option()
        cssClass: string;

        @Serenity.Decorators.option()
        target: string;
    }
}